import { RuleDecl } from "vue/types/options";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import Countries from "./Countries";

export const validations: RuleDecl = {
    countryName: {
        countryNameRequired: required,
        minCountryNameLength: minLength(2),
        maxCountryNameLength: maxLength(50),
        unique: (value: string, component: Countries) => {
            if (!!component) {
                return (component.countries?.findIndex(u => u.name.localeCompare(value) === 0) < 0 ?? true);
            } else {
                return true;
            }
        },
    },
    countryValue: {
        countryRequired: required,
        minCountryLength: minLength(4),
        maxCountryLength: maxLength(300),
        unique: (value: string, component: Countries) => {
            if (!!component) {
                return (component.countries?.findIndex(u => u.value.localeCompare(value) === 0) < 0 ?? true);
            } else {
                return true;
            }
        },
    },
    editingCountryName: {
        countryNameRequired: required,
        minCountryNameLength: minLength(2),
        maxCountryNameLength: maxLength(50),
        uniqueName: (value: string, component: Countries) => {
            if (!!component) {
                return (component.countries?.findIndex(u => u.name.localeCompare(value) === 0 &&
                    u.countryId !== component.editingCountryId) < 0 ?? true);
            } else {
                return true;
            }
        },
    },
    editingCountryValue: {
        countryRequired: required,
        minCountryLength: minLength(4),
        maxCountryLength: maxLength(300),
        unique: (value: string, component: Countries) => {
            if (!!component) {
                return (component.countries?.findIndex(u => u.value.localeCompare(value) === 0 &&
                    u.countryId !== component.editingCountryId) < 0 ?? true);
            } else {
                return true;
            }
        },
    },
};

export const validationMessages = {
    countryNameRequired: "Country code is required",
    minCountryNameLength: "Country code must have at least {min} letters",
    maxCountryNameLength: "Country code must have less than {max} letters",
    uniqueName: "Country code must be unique",
    countryRequired: "Country name is required",
    minCountryLength: "Country name must have at least {min} letters",
    maxCountryLength: "Country name must have less than {max} letters",
    unique: "Country name must be unique",
};
